import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface SignIn {
  loading: boolean;
  error: string | null;
  data: SignInData;
}

export interface SignInData {
  phoneNumber: string | null;
  isOTPsent?: boolean | null;
  isNumberAlreadyRegistered?: boolean | null;
  isOTPValid?: boolean | null;
}

export const signInDetailsState: SignIn = {
  data: {
    phoneNumber: null,
    isOTPsent: false,
    isNumberAlreadyRegistered: false,
    isOTPValid: false,
  },
  loading: false,
  error: null,
};

const SignInSlice = createSlice({
  name: 'form',
  initialState: signInDetailsState,
  reducers: {
    setSendOTP: (state, action: PayloadAction<SignInData>) => {
      state.data.phoneNumber = action.payload.phoneNumber;
      state.data.isOTPsent = true;
      state.data.isNumberAlreadyRegistered = false;
    },
    setValidOTP: (state, action?: PayloadAction<void>) => {
      state.data.isOTPValid = true;
      state.data.isOTPsent = true;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setSendOTP, setLoading, setError, setValidOTP } =
  SignInSlice.actions;

export default SignInSlice.reducer;
